"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskSecret = maskSecret;
exports.maskSecretFromEnv = maskSecretFromEnv;
exports.convertToAlphanumericOnly = convertToAlphanumericOnly;
exports.getResourceGroupNameFromResourceId = getResourceGroupNameFromResourceId;
exports.parseFromResourceId = parseFromResourceId;
exports.getUuid = getUuid;
exports.getHashedEnv = getHashedEnv;
exports.loadingOptionsPlaceholder = loadingOptionsPlaceholder;
exports.loadingDefaultPlaceholder = loadingDefaultPlaceholder;
exports.isValidHttpUrl = isValidHttpUrl;
const tslib_1 = require("tslib");
const crypto = tslib_1.__importStar(require("crypto"));
const Handlebars = tslib_1.__importStar(require("handlebars"));
const url_1 = require("url");
const uuid = tslib_1.__importStar(require("uuid"));
const common_1 = require("../error/common");
const localizeUtils_1 = require("./localizeUtils");
const masker_1 = require("./secretmasker/masker");
const SECRET_REPLACE = "<REDACTED:secret>";
function maskSecret(inputText, option) {
    if (!inputText)
        return "";
    const replace = option?.replace || SECRET_REPLACE;
    let output = maskSecretFromEnv(inputText);
    output = masker_1.secretMasker.maskSecret(output, replace, option?.whiteList);
    return output;
}
function maskSecretFromEnv(stdout, replace = SECRET_REPLACE) {
    for (const key of Object.keys(process.env)) {
        if (key.startsWith("SECRET_")) {
            const value = process.env[key];
            if (value) {
                const escapedValue = value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                stdout = stdout.replace(new RegExp(escapedValue, "g"), replace);
            }
        }
    }
    return stdout;
}
function convertToAlphanumericOnly(appName) {
    return appName.replace(/[^\da-zA-Z]/g, "");
}
Handlebars.registerHelper("contains", (value, array) => {
    array = array instanceof Array ? array : [array];
    return array.indexOf(value) > -1 ? this : "";
});
Handlebars.registerHelper("notContains", (value, array) => {
    array = array instanceof Array ? array : [array];
    return array.indexOf(value) == -1 ? this : "";
});
Handlebars.registerHelper("equals", (value, target) => {
    return value === target ? this : "";
});
function getResourceGroupNameFromResourceId(resourceId) {
    const result = parseFromResourceId(/\/resourceGroups\/([^\/]*)\//i, resourceId);
    if (!result) {
        throw new common_1.FailedToParseResourceIdError("resource group name", resourceId);
    }
    return result;
}
function parseFromResourceId(pattern, resourceId) {
    const result = resourceId.match(pattern);
    return result ? result[1].trim() : "";
}
function getUuid() {
    return uuid.v4();
}
function getHashedEnv(envName) {
    return crypto.createHash("sha256").update(envName).digest("hex");
}
function loadingOptionsPlaceholder() {
    return (0, localizeUtils_1.getLocalizedString)("ui.select.LoadingOptionsPlaceholder");
}
function loadingDefaultPlaceholder() {
    return (0, localizeUtils_1.getLocalizedString)("ui.select.LoadingDefaultPlaceholder");
}
function isValidHttpUrl(input) {
    let url;
    try {
        url = new url_1.URL(input);
        return url.protocol === "http:" || url.protocol === "https:";
    }
    catch (e) {
        return false;
    }
}
//# sourceMappingURL=stringUtils.js.map